<template>
  <a-upload
    name="file"
    :action="`${baseUrl}/filestream/json/import`"
    :maxCount="1"
    :showUploadList="false"
    :headers="headers"
    accept=".json, .json5"
    @change="handleChange"
  >
    <HKLButton
      action="import"
      color="darkblue"
    />
  </a-upload>
</template>
<script>
import { ref, onMounted, getCurrentInstance } from 'vue-demi'
import HKLButton from '@/controls/Button/HKLButton'
import { useBaseUrl } from '@/utils/http/hook'
import httpHeaderMixin from '@/controls/httpHeaderMixin'
import notification from '@/utils/notification'
import i18n from '@/utils/i18n'

const SOURCE = '_value'
const EVENT = '_change'

export default {
  name: 'HKLUploadButton',
  components: {
    HKLButton,
  },
  mixins: [httpHeaderMixin],

  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    [SOURCE]: {
      type: Array,
      default: () => ['', ''],
    },

  },
  setup (props, { emit }) {
    const { proxy } = getCurrentInstance()
    let headers = ref({})

    const fileList = ref([])
    const handleChange = info => {
      if (info.file.status === 'done') {
        const result = info.file.response.data
        emit('importFile', result)
        notification.fireNotification(true, i18n.t('success'))
      } else if (info.file.status === 'error') {
        const err = info.file
        notification.handleResponseError(err, 'import')
      }
    }

    onMounted(async () => {
      const requestHeader = await proxy.getHttpHeaders()
      headers.value = requestHeader
    })
    return {
      fileList,
      baseUrl: useBaseUrl(),
      handleChange,
      headers,
    }
  },
}
</script>
